import * as svg from "../../../assets/arrow-left.svg";

import {iconBuilder} from "./iconBuilder";

export const ArrowLeftIcon = iconBuilder(svg, "ArrowLeftIcon", "0 0 24 24");
